import {useEffect, useState} from "react";
import {Box, Button, Grid, Tab, TextField, Typography} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogActions from "@material-ui/core/DialogActions";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashGroupService} from "../CashGroups/CashGroupService";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {css} from "@emotion/css";
import RaikoMultiSelectTable from "../../component/raikoComponent/raikoMultiSelectTable/RaikoMultiSelectTable";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import ReportItems, {ReportsItemTypes} from "../../component/reportItem/ReportItems";
import {RaikoGridOneColumn, RaikoGridThreeColumn} from "@moeindal/base-raiko-panel-components";

const CashGroupInfo = ({needRefresh, selectedItemId}) => {
    let page = 0
    const size = 15

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashGroupService(fundID, token, snackbar, loading)

    const [fundCode, setFundCode] = useState("");

    const [groupName, setGroupName] = useState("");
    const [enabled, setEnabled] = useState(true);


    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);
    //Dialog-end

    useEffect(() => {
        if (selectedItemId && parseInt(selectedItemId) >= 0) {
            getCashGroupsFromServer(selectedItemId)
            getGroupMembersListFromServer()

        }

    }, [selectedItemId])

    function getGroupMembersListFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getGroupUsersList(fundID, selectedItemId, page, size)
            .then(response => {
                setTeamLeaderList([])
                response.data.map((item, index) => {
                    setTeamLeaderList(prevState => [
                        ...prevState,
                        prepareTableItems(
                            (size * page) + index + 1,
                            item.id,
                            `${item.firstName} ${item.lastName}`,
                            item.nationalCode,
                            item.phoneNumber
                        )
                    ])
                })

                setPageCount(response.totalPage)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            new ServerErrorHandler(reason, "خطا در دریافت لیست اعضا گروه", snackbar, loading)
        })
    }

    function getCashGroupsFromServer(selectedItemId) {
        loading(setLoadingStateDispatch(true))
        service.getCashGroupInfoFromServer(fundID, selectedItemId)
            .then(response => {
                setGroupName(response.name)
                setEnabled(response.enabled)
                setFundCode(response.code)
                loading(setLoadingStateDispatch(false))

                if (response.groupLeader) {
                    setSelectedTeamLeader([{
                        id: response.groupLeader.id,
                        title: `${response.groupLeader.firstName} ${response.groupLeader.lastName}`
                    }])
                }

            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات گروه", snackbar, loading)
        })
    }

    function doChange() {
        if (checkFieldsConditions()) {
            needRefresh(true)

            if (selectedItemId < 0) {
                service.addNewGroup(
                    fundID,
                    fundCode,
                    groupName,
                    enabled,
                    clearFieldsData
                )

            } else {
                service.updateCashGroupInfo(
                    fundID,
                    fundCode,
                    selectedItemId,
                    groupName,
                    enabled
                )
            }
        }
    }

    function checkFieldsConditions() {
        if (groupName.trim().length === 0) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا نام گروه را مشخص نمایید!"))
            return false
        }
        return true
    }

    function clearFieldsData() {
        setFundCode("")
        setGroupName("")
        setEnabled(true)
        setSelectedTeamLeader([])
    }

    //
    const [pageCount, setPageCount] = useState(2)
    const [selectedTeamLeader, setSelectedTeamLeader] = useState([])
    const [teamLeaderList, setTeamLeaderList] = useState([])

    function handleChangePagination(newPage) {
        page = newPage
        getGroupMembersListFromServer()
    }

    function handleUpdateLeader() {
        if (selectedTeamLeader.length > 0) {
            loading(setLoadingStateDispatch(true))
            service.updateGroupLeader(fundID, selectedItemId, selectedTeamLeader[0].id)
                .then(response => {
                    snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "مدیر گروه با موفقیت بروزرسانی شد."))
                    loading(setLoadingStateDispatch(false))
                }).catch(reason => {
                new ServerErrorHandler(reason, "خطا در بروزرسانی مدیر گروه", snackbar, loading)
            })

        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا مدیر گروه مورد نظر خود را انتخاب نمایید!"))
        }
    }

    const [selectedTab, setSelectedTab] = useState(cashGroupInfoType.BASIC_INFORMATION)

    function handleTabChange(event, newValue) {
        setSelectedTab(newValue)
    }

    return (
        <div className={css`display: flex;
          flex-direction: column;`}>
            <section className={css`padding: 0 1rem 1rem 1rem;
              width: 100%`}>
                <TabContext value={selectedTab}>
                    {
                        selectedItemId < 0 ? "" : <TabList onChange={handleTabChange} id="default-tab-container">
                            <Tab
                                label={"مشخصات"}
                                value={cashGroupInfoType.BASIC_INFORMATION}
                            />
                            <Tab
                                label={"انتخاب مدیر"}
                                value={cashGroupInfoType.SELECTED_MANAGER}
                            />
                            <Tab
                                label={"گزارشات"}
                                value={cashGroupInfoType.GET_REPORT}
                            />
                        </TabList>
                    }
                    <TabPanel value={cashGroupInfoType.BASIC_INFORMATION}>
                        <Box className={css`display: flex;
                          margin-top: 1rem !important;
                          margin-bottom: 1rem !important;
                        `}>

                            {
                                selectedItemId === -1 ?
                                    <RaikoGridOneColumn className={"w-100"}>
                                        <TextField
                                            className="w-100"
                                            id="outlined-disabled"
                                            label="کد گروه"
                                            variant="outlined"
                                            value={fundCode}
                                            onChange={e => {

                                                setFundCode(e.target.value)
                                            }}
                                        />
                                        <TextField
                                            className="w-100"
                                            id="outlined-disabled"
                                            label="نام گروه"
                                            variant="outlined"
                                            value={groupName}
                                            onChange={e => {
                                                setGroupName(e.target.value)
                                            }}
                                        />
                                        <label id='residenceStatus' className="toggle-switch-content">
                                            <span className="toggle-title">فعال/غیر فعال</span>
                                            <label className="switch" htmlFor="MainCategory">
                                                <input
                                                    type="checkbox"
                                                    id="residenceStatus"
                                                    checked={enabled}
                                                    onChange={e => {
                                                        setEnabled(e.target.checked)
                                                    }}
                                                />
                                                <span className="toggle round"/>
                                            </label>

                                        </label>
                                    </RaikoGridOneColumn> :

                                    <RaikoGridThreeColumn className={"w-100"}>
                                        <TextField
                                            className="w-100"
                                            id="outlined-disabled"
                                            label="کد گروه"
                                            variant="outlined"
                                            value={fundCode}
                                            onChange={e => {

                                                setFundCode(e.target.value)
                                            }}
                                        />
                                        <TextField
                                            className="w-100"
                                            id="outlined-disabled"
                                            label="نام گروه"
                                            variant="outlined"
                                            value={groupName}
                                            onChange={e => {
                                                setGroupName(e.target.value)
                                            }}
                                        />
                                        <label id='residenceStatus' className="toggle-switch-content">
                                            <span className="toggle-title">فعال/غیر فعال</span>
                                            <label className="switch" htmlFor="MainCategory">
                                                <input
                                                    type="checkbox"
                                                    id="residenceStatus"
                                                    checked={enabled}
                                                    onChange={e => {
                                                        setEnabled(e.target.checked)
                                                    }}
                                                />
                                                <span className="toggle round"/>
                                            </label>

                                        </label>
                                    </RaikoGridThreeColumn>
                            }
                        </Box>
                        <div className={css`display: flex;
                          justify-content: end`}>
                            <Button onClick={doChange} color="primary">
                                {selectedItemId < 0 ? "افزودن گروه" : "بروزرسانی"}
                            </Button>
                        </div>
                    </TabPanel>
                    <TabPanel value={cashGroupInfoType.SELECTED_MANAGER}>
                        {
                            selectedItemId < 0 ? "" :
                                <div
                                    className={css`
                                      display: flex;
                                      flex-direction: column;
                                      margin-top: 1rem;
                                      justify-content: end;`}>
                                    <RaikoMultiSelectTable
                                        isSingleSelect={true}
                                        pageCount={pageCount}
                                        setSelectedItems={setSelectedTeamLeader}
                                        handleChangePagination={handleChangePagination}
                                        tableData={teamLeaderList}
                                        tableHeader={teamLeaderHeader}
                                        selectedItems={selectedTeamLeader}/>

                                    <div className={css`display: flex;
                                      justify-content: end`}>
                                        <Button onClick={handleUpdateLeader} color="primary">
                                            {selectedItemId < 0 ? "افزودن گروه" : "بروزرسانی"}
                                        </Button>
                                    </div>

                                </div>
                        }
                    </TabPanel>
                    <TabPanel value={cashGroupInfoType.GET_REPORT}>
                        <section className={css`
                          margin-top: 1rem;
                          gap: 16px;
                          display: flex;
                          flex-direction: column;
                        `}>
                            <ReportItems
                                title={"دریافت گزارش گروه"}
                                downloadExcel={_ => {
                                    service.downloadGroupReports(selectedItemId, ReportsItemTypes.XLSX, groupName)
                                }}
                                downloadPdf={_ => {
                                    service.downloadGroupReports(selectedItemId, ReportsItemTypes.PDF, groupName)
                                }}
                            />
                        </section>
                    </TabPanel>
                </TabContext>
            </section>
        </div>

    )

};

export default CashGroupInfo;
export const teamLeaderHeader = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'phoneNumber',
        label: 'شماره تلفن همراه',
        align: 'right',
    }
]
const cashGroupInfoType = {
    BASIC_INFORMATION: "BASIC_INFORMATION",
    SELECTED_MANAGER: "SELECTED_MANAGER",
    GET_REPORT: "GET_REPORT",
}


function prepareTableItems(number, id, fullName, nationalCode, phoneNumber) {
    return {
        id,
        title: fullName,

        number,
        fullName,
        nationalCode,
        phoneNumber: phoneNumber && phoneNumber.length > 5 ? phoneNumber : "-"
    }
}